import React, { Component } from "react";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Help from "@material-ui/icons/Help";
import Chat from "@material-ui/icons/Chat";
import ChatSupport from "@material-ui/icons/Forum";

import HomeIcon from "@material-ui/icons/HomeOutlined";
import AcccountsIcon from "@material-ui/icons/AccountBalanceOutlined";
import CompanyIcon from "@material-ui/icons/BusinessOutlined";
import ProfileIcon from "@material-ui/icons/SubjectOutlined";
import UserIcon from "@material-ui/icons/PersonOutlined";
import ContactIcon from "@material-ui/icons/EmailOutlined";

import ListItemIcon from "@material-ui/core/ListItemIcon";

import ChatDialog from "../components/ChatDialog";
import ChatSupportDialog from "../components/ChatSupportDialog";
import { APP_BAR_HEIGHT, DRAWER_WIDTH } from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import {
  SMALL_ITEMS_PER_PAGE,
  LARGE_ITEMS_PER_PAGE,
  APPNAME,
  TOMCAT_DEV_PORT,
  TOMCAT_DEV_PORT_BNK,
} from "../components/Constants";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

import HomePage from "../containers/HomePage";
import AccountsPage from "../containers/AccountsPage";
import CompanyProfilePage from "../containers/CompanyProfilePage";
import ProfilePage from "../containers/ProfilePage";
import UserManagementPage from "../containers/UserManagementPage";
import ContactUsPage from "../containers/ContactUsPage";

import LogoutIcon from "@material-ui/icons/ExitToAppOutlined";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  appFrame: {
    height: `calc(100% - ${APP_BAR_HEIGHT}px)`,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
  },
  appBar: {
    width: `100%`,
    heigh: `${APP_BAR_HEIGHT}px`,
    position: "fixed",
  },
  errorBar: {
    width: `100%`,
    heigh: `200px`,
    top: `${APP_BAR_HEIGHT}px`,
    position: "fixed",
  },
  drawerPaper: {
    position: "fixed",
    width: `${DRAWER_WIDTH}px`,
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    overflow: "hidden",
  },
});

class MainPage extends Component {
  constructor(props) {
    super(props);
    const root = document.getElementById("root");
    const use_static_logout_page = root.getAttribute("use_static_logout_page");
    window.sco_small_items_per_page = SMALL_ITEMS_PER_PAGE;
    window.sco_large_items_per_page = LARGE_ITEMS_PER_PAGE;
    this.state = {
      errorString: "",
      userName: "",
      realm: "",
      companyName: "",
      readAccount: false,
      readProfile: false,
      readCompanyProfile: false,
      userManagement: false,
      homePage: false,
      accountsPage: false,
      companyProfilePage: false,
      profilePage: false,
      userManagementPage: false,
      contactUsPage: false,
      helpUrlParams: "",
      logoFile: "",
      customDrawer: false,
      openSocket: false,
      socketReady: false,
      socketFailOpen: 0,
      ws: null,
      chatStarted: false,
      fromUser: "",
      chatObject: null,
      chatPaused: false,
      savedChatState: null,
      chatWakeMessages: [],
      openSocketSupport: false,
      socketSupportReady: false,
      socketSupportFailOpen: 0,
      wsSupport: null,
      chatSupportStarted: false,
      fromUserSupport: "",
      chatSupportObject: null,
      chatSupportPaused: false,
      savedChatSupportState: null,
      chatSupportWakeMessages: [],
      uiExclusionsList: [],
      viewOnly: false,
      options: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      },
      date: new Date(),
      use_static_logout_page: use_static_logout_page,
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.handleHome = this.handleHome.bind(this);
    this.handleAccount = this.handleAccount.bind(this);
    this.handleCompanyProfile = this.handleCompanyProfile.bind(this);
    this.handleProfile = this.handleProfile.bind(this);
    this.handleUserManagement = this.handleUserManagement.bind(this);
    this.handleContactUs = this.handleContactUs.bind(this);
    this.handleHelp = this.handleHelp.bind(this);
    this.onCompanyNameChange = this.onCompanyNameChange.bind(this);
    this.onSocketOpen = this.onSocketOpen.bind(this);
    this.onSocketClose = this.onSocketClose.bind(this);
    this.onSocketMessage = this.onSocketMessage.bind(this);
    this.beginChat = this.beginChat.bind(this);
    this.onChatEnd = this.onChatEnd.bind(this);
    this.submitSocketMessage = this.submitSocketMessage.bind(this);
    this.chatCallback = this.chatCallback.bind(this);

    this.onSocketSupportOpen = this.onSocketSupportOpen.bind(this);
    this.onSocketSupportClose = this.onSocketSupportClose.bind(this);
    this.onSocketSupportMessage = this.onSocketSupportMessage.bind(this);
    this.beginChatSupport = this.beginChatSupport.bind(this);
    this.onChatSupportEnd = this.onChatSupportEnd.bind(this);
    this.submitSocketSupportMessage = this.submitSocketSupportMessage.bind(
      this
    );
    this.chatSupportCallback = this.chatSupportCallback.bind(this);
  }

  handleHelp = (event) => {
    var strWindowFeatures =
      "location=yes,height=400,width=809,scrollbars=yes,status=yes, resizable=yes";
    var URL =
      window.location.origin +
      "/comp_help/Default.htm" +
      this.state.helpUrlParams;
    window.open(URL, "_blank", strWindowFeatures).focus();
  };

  onCompanyNameChange(newName) {
    this.setState({ companyName: newName });
  }

  handleHome(e) {
    e.preventDefault();
    this.resetChildPages();
    this.setState({ homePage: true });
    this.setState({ helpUrlParams: "#Topics/Home/Home Company.htm" });
  }

  handleAccount(e) {
    e.preventDefault();
    this.resetChildPages();
    this.setState({ accountsPage: true });
    this.setState({
      helpUrlParams: "#Topics/Accounts/Accounts in Company.htm",
    });
  }
  handleCompanyProfile(e) {
    e.preventDefault();
    this.resetChildPages();
    this.setState({ companyProfilePage: true });
    this.setState({
      helpUrlParams:
        "#Topics/User Profile Maintenance/Company Profile Maintenance.htm",
    });
  }
  handleProfile(e) {
    e.preventDefault();
    this.resetChildPages();
    this.setState({ profilePage: true });
    this.setState({
      helpUrlParams:
        "#Topics/User Profile Maintenance/User Profile Maintenance.htm",
    });
  }
  handleUserManagement(e) {
    e.preventDefault();
    this.resetChildPages();
    this.setState({ userManagementPage: true });
    this.setState({
      helpUrlParams: "#Topics/User Management/User Management.htm",
    });
  }
  handleContactUs(e) {
    e.preventDefault();
    this.resetChildPages();
    this.setState({ contactUsPage: true });
    this.setState({
      helpUrlParams:
        "#Topics/User Profile Maintenance/Contacting Customer Support.htm",
    });
  }

  resetChildPages() {
    this.setState({ homePage: false });
    this.setState({ accountsPage: false });
    this.setState({ companyProfilePage: false });
    this.setState({ profilePage: false });
    this.setState({ userManagementPage: false });
    this.setState({ contactUsPage: false });
  }

  handleLogout(e) {
    e.preventDefault();
    fetch("on_logout", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        if (window.sco_return_url) {
          window.location.href = window.sco_return_url;
        } else {
          if (this.state.viewOnly) {
            this.props.history.push("/support");
          } else {
            if (this.state.use_static_logout_page === "1") {
              this.props.history.push("/staticlogout");
            } else {
              this.props.history.push("/");
            }
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  onSocketOpen() {
    this.setState({ socketFailOpen: 0 });
    this.setState({ openSocket: true });
  }

  onSocketClose() {
    this.setState({ socketReady: false });
    let socketFailOpen = this.state.socketFailOpen + 1;
    if (socketFailOpen > 5) {
      this.setState({ ws: null });
    } else {
      this.setState({ socketFailOpen: socketFailOpen });
      this.createSocket();
    }
  }

  initSocketMessage() {
    let payload = JSON.stringify({
      messageType: 1,
      user: this.state.userName,
      realm: this.state.realm,
    });
    this.submitSocketMessage(payload);
  }

  onSocketMessage(e) {
    const message = JSON.parse(e.data);

    // confirmed init socket
    if (message.messageType === 1) {
      this.setState({ socketReady: true });
    }
    // chat request
    else if (message.messageType === 2) {
      // can't start another chat, decline
      if (this.state.chatStarted || this.state.chatSupportStarted) {
        let payload = JSON.stringify({
          messageType: -1,
          user: "SYSTEM",
          realm: this.state.realm,
          message:
            this.state.userName + " is chatting with someone else. Try later.",
          toUser: message.user,
        });
        this.submitSocketMessage(payload);
      } else {
        let payload = JSON.stringify({
          messageType: 3,
          user: "SYSTEM",
          realm: this.state.realm,
          message: "",
          toUser: message.user,
        });
        this.submitSocketMessage(payload);
        this.setState({ fromUser: message.user });
        this.setState({ chatStarted: true });
      }
    } else {
      if (this.state.chatPaused) {
        let messages = this.state.chatWakeMessages;
        messages.push(message);
        this.setState({ chatWakeMessages: messages });
        this.setState({ chatPaused: false });
      } else if (this.state.chatObject !== null) {
        this.state.chatObject.handleMessage(message);
      }
    }
  }

  submitSocketMessage(message) {
    if (this.state.ws !== null) {
      this.state.ws.send(message);
    }
  }

  createSocket() {
    let wsUrl;
    //let orig = this.props.location.search;
    if (process.env.NODE_ENV === "development") {
      wsUrl = "ws://localhost:" + TOMCAT_DEV_PORT + "/web_socket_main";
    } else {
      let origin = window.location.href;
      //let origin = process.env.PUBLIC_URL;
      let n = origin.indexOf("#");
      origin = origin.substring(0, n) + "web_socket_main";

      if (window.location.protocol === "http:") {
        wsUrl = "ws:";
      } else {
        wsUrl = "wss:";
      }
      wsUrl = wsUrl + origin.substring(window.location.protocol.length);
    }
    let ws = new WebSocket(wsUrl);
    this.setState({ ws: ws });
    ws.onopen = this.onSocketOpen;
    ws.onclose = this.onSocketClose;
    ws.onmessage = this.onSocketMessage;
  }

  onSocketSupportOpen() {
    this.setState({ socketSupportFailOpen: 0 });
    this.setState({ openSocketSupport: true });
  }

  onSocketSupportClose() {
    this.setState({ socketSupportReady: false });
    let socketSupportFailOpen = this.state.socketSupportFailOpen + 1;
    if (socketSupportFailOpen > 5) {
      this.setState({ wsSupport: null });
    } else {
      this.setState({ socketSupportFailOpen: socketSupportFailOpen });
      this.createSocketSupport();
    }
  }

  initSocketSupportMessage() {
    let payload = JSON.stringify({
      messageType: 1,
      user: this.state.userName,
      realm: this.state.realm,
      bankRealm: this.state.bankRealm,
    });
    this.submitSocketSupportMessage(payload);
  }

  onSocketSupportMessage(e) {
    const message = JSON.parse(e.data);

    // confirmed init socket
    if (message.messageType === 1) {
      this.setState({ socketSupportReady: true });
    }
    // chat request
    else if (message.messageType === 2) {
      // can't start another chat, decline
      if (this.state.chatSupportStarted || this.state.chatStarted) {
        let payload = JSON.stringify({
          messageType: -1,
          user: "SYSTEM",
          realm: this.state.realm,
          message:
            this.state.userName + " is chatting with someone else. Try later.",
          toUser: message.user,
        });
        this.submitSocketSupportMessage(payload);
      } else {
        let payload = JSON.stringify({
          messageType: 3,
          user: "SYSTEM",
          realm: this.state.realm,
          bankRealm: this.state.bankRealm,
          message: "",
          toUser: message.user,
        });
        this.submitSocketSupportMessage(payload);
        this.setState({ fromUser: message.user });
        this.setState({ chatSupportStarted: true });
      }
    } else {
      if (this.state.chatSupportPaused) {
        let messages = this.state.chatSupportWakeMessages;
        messages.push(message);
        this.setState({ chatSupportWakeMessages: messages });
        this.setState({ chatSupportPaused: false });
      } else if (this.state.chatSupportObject !== null) {
        this.state.chatSupportObject.handleMessage(message);
      }
    }
  }

  submitSocketSupportMessage(message) {
    if (this.state.wsSupport !== null) {
      this.state.wsSupport.send(message);
    }
  }

  createSocketSupport() {
    let wsUrl;
    if (process.env.NODE_ENV === "development") {
      wsUrl = "ws://localhost:" + TOMCAT_DEV_PORT_BNK + "/web_socket_support";
    } else {
      /*let origin = window.location.href;
			let n = origin.indexOf("#");
			origin = origin.substring(0, n) + "web_socket_main";*/

      const root = document.getElementById("root");
      const websocketsupporturl = root.getAttribute("support_websocket-url");

      let origin = window.location.href;
      let n = origin.indexOf("/#");
      origin = origin.substring(0, n);
      let m = origin.lastIndexOf("/");
      origin =
        origin.substring(0, m) + websocketsupporturl + "web_socket_support";

      if (window.location.protocol === "http:") {
        wsUrl = "ws:";
      } else {
        wsUrl = "wss:";
      }
      wsUrl = wsUrl + origin.substring(window.location.protocol.length);
    }
    let wsSupport = new WebSocket(wsUrl);
    this.setState({ wsSupport: wsSupport });
    wsSupport.onopen = this.onSocketSupportOpen;
    wsSupport.onclose = this.onSocketSupportClose;
    wsSupport.onmessage = this.onSocketSupportMessage;
  }

  componentDidMount() {
    this.timerId = setInterval(() => this.tick(), 1000);
    if (
      "yes" === this.props.customTheme &&
      window.sco_custom_theme.customDrawer !== undefined
    ) {
      this.setState({ customDrawer: true });
    }
    fetch("on_main_nav_entry", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ userName: reply.userName });
          this.setState({ realm: reply.realm });
          this.setState({ bankRealm: reply.bankRealm });
          this.setState({ companyName: reply.companyName });
          if (reply.error) this.setState({ errorString: reply.errorString });
          this.setState({ readAccount: reply.readAccount });
          this.setState({ readProfile: reply.readProfile });
          this.setState({ readCompanyProfile: reply.readCompanyProfile });
          this.setState({ userManagement: reply.userManagement });
          this.setState({ logoFile: reply.logoFileName });
          this.setState({ uiExclusionsList: reply.ui_exclusions });
          this.setState({ viewOnly: reply.viewOnly });
          this.resetChildPages();
          this.setState({ homePage: true });
          this.setState({
            helpUrlParams: "?cur_sec=accounts&sub_sec=&from=main",
          });
          this.createSocket();
          this.createSocketSupport();
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  componentDidUpdate() {
    if (this.state.openSocket) {
      this.initSocketMessage();
      this.setState({ openSocket: false });
    }
    if (this.state.openSocketSupport) {
      this.initSocketSupportMessage();
      this.setState({ openSocketSupport: false });
    }
    if (
      this.state.chatSupportWakeMessages.length > 0 &&
      this.state.chatSupportObject !== null
    ) {
      let i;
      for (i = 0; i < this.state.chatSupportWakeMessages.length; i++) {
        this.state.chatSupportObject.handleMessage(
          this.state.chatSupportWakeMessages[i]
        );
      }
      this.setState({ chatSupportWakeMessages: [] });
    }
    if (
      this.state.chatWakeMessages.length > 0 &&
      this.state.chatObject !== null
    ) {
      let i;
      for (i = 0; i < this.state.chatWakeMessages.length; i++) {
        this.state.chatObject.handleMessage(this.state.chatWakeMessages[i]);
      }
      this.setState({ chatWakeMessages: [] });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerId);
    if (this.state.ws !== null) {
      let ws = this.state.ws;
      ws.onclose = null;
      ws.close();
    }
    if (this.state.wsSupport !== null) {
      let ws = this.state.wsSupport;
      ws.onclose = null;
      ws.close();
    }
  }

  tick() {
    this.setState({ date: new Date() });
  }

  beginChat(e) {
    if (this.state.chatPaused) {
      this.setState({ chatPaused: false });
    } else {
      this.setState({ savedChatState: null });
      this.setState({ chatStarted: true });
    }
  }

  onChatEnd(pause, savedState) {
    if (pause) {
      this.setState({ savedChatState: savedState });
      this.setState({ chatPaused: true });
      this.setState({ chatObject: null });
    } else {
      this.setState({ savedChatState: null });
      this.setState({ chatWakeMessages: [] });
      this.setState({ chatStarted: false });
      this.setState({ chatPaused: false });
      this.setState({ chatObject: null });
      this.setState({ fromUser: "" });
    }
  }

  chatCallback(obj) {
    this.setState({ chatObject: obj });
  }

  beginChatSupport(e) {
    if (this.state.chatSupportPaused) {
      this.setState({ chatSupportPaused: false });
    } else {
      this.setState({ savedChatSupportState: null });
      this.setState({ chatSupportStarted: true });
    }
  }

  onChatSupportEnd(pause, savedState) {
    if (pause) {
      this.setState({ savedChatSupportState: savedState });
      this.setState({ chatSupportPaused: true });
      this.setState({ chatSupportObject: null });
    } else {
      this.setState({ savedChatSupportState: null });
      this.setState({ chatSupportWakeMessages: [] });
      this.setState({ chatSupportStarted: false });
      this.setState({ chatSupportPaused: false });
      this.setState({ chatSupportObject: null });
      this.setState({ fromUserSupport: "" });
    }
  }

  chatSupportCallback(obj) {
    this.setState({ chatSupportObject: obj });
  }

  render() {
    let { t } = this.props;
    const { classes } = this.props;
    return (
      <div>
        {this.state.chatStarted && !this.state.chatPaused && (
          <ChatDialog
            history={this.props.history}
            refChat={this.chatCallback}
            onClose={this.onChatEnd}
            fromUser={this.state.fromUser}
            user={this.state.userName}
            realm={this.state.realm}
            send={this.submitSocketMessage}
            savedState={this.state.savedChatState}
          />
        )}
        {this.state.chatSupportStarted && !this.state.chatSupportPaused && (
          <ChatSupportDialog
            history={this.props.history}
            refChatSupport={this.chatSupportCallback}
            onClose={this.onChatSupportEnd}
            fromUser={this.state.fromUserSupport}
            user={this.state.userName}
            realm={this.state.realm}
            bankRealm={this.state.bankRealm}
            send={this.submitSocketSupportMessage}
            savedState={this.state.savedChatSupportState}
          />
        )}
        <AppBar position="static" className={classes.appBar}>
          <Toolbar>
            {this.state.logoFile.length === 0 && (
              <Typography variant="h6" color="inherit">
                {APPNAME}
              </Typography>
            )}
            {this.state.logoFile.length > 0 && (
              <img
                src={
                  "logo/logo_" +
                  this.state.imageFile
                }
                alt="Not Available"
                style={{ maxWidth: "140px", maxHeight: "60px" }}
              />
            )}
            <Tooltip title={t("help.tip")}>
              <IconButton onClick={this.handleHelp} color="inherit">
                <Help />
              </IconButton>
            </Tooltip>
            {this.state.socketReady && !this.state.chatSupportPaused && (
              <Tooltip
                title={
                  this.state.chatPaused
                    ? t("resumeChatWtC.tip")
                    : t("chatWtC.tip")
                }
              >
                <IconButton onClick={this.beginChat} color="inherit">
                  <Chat s />
                </IconButton>
              </Tooltip>
            )}
            {this.state.socketSupportReady && !this.state.chatPaused && (
              <Tooltip
                title={
                  this.state.chatSupportPaused
                    ? t("resumeChatWtB.tip")
                    : t("chatWtB.tip")
                }
              >
                <IconButton onClick={this.beginChatSupport} color="inherit">
                  <ChatSupport cs />
                </IconButton>
              </Tooltip>
            )}
            <p style={{ width: 600, marginRight: "auto", marginLeft: "auto" }}>
              {" "}
              {t("company.label")} {this.state.companyName} &nbsp;&nbsp;{" "}
              {t("user.label")} {this.state.userName}{" "}
            </p>
            <p>
              {this.state.date.toLocaleDateString("en-US", this.state.options)}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </p>
            <Button
              style={{ right: 20 }}
              color="inherit"
              onClick={this.handleLogout}
            >
              <LogoutIcon />
              &nbsp;{t("logout.label")}
            </Button>
          </Toolbar>
        </AppBar>
        {this.state.errorString.length > 0 && (
          <div className={classes.errorBar}>
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
          </div>
        )}
        {this.state.errorString.length === 0 && (
          <div className={classes.appFrame}>
            <Drawer
              variant="permanent"
              classes={{
                paper: classes.drawerPaper,
              }}
              anchor="left"
            >
              <div className={classes.toolbar} />
              <Divider />
              {!this.state.customDrawer && (
                <List>
                  <MenuItem
                    button
                    onClick={this.handleHome}
                    selected={this.state.homePage}
                  >
                    <ListItemIcon className={classes.icon}>
                      <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("home.button")} />
                  </MenuItem>
                  {this.state.readAccount && (
                    <MenuItem
                      button
                      onClick={this.handleAccount}
                      selected={this.state.accountsPage}
                    >
                      <ListItemIcon className={classes.icon}>
                        <AcccountsIcon />
                      </ListItemIcon>
                      <ListItemText primary={t("accounts.button")} />
                    </MenuItem>
                  )}
                  {this.state.readCompanyProfile && (
                    <MenuItem
                      button
                      onClick={this.handleCompanyProfile}
                      selected={this.state.companyProfilePage}
                    >
                      <ListItemIcon className={classes.icon}>
                        <CompanyIcon />
                      </ListItemIcon>
                      <ListItemText primary={t("companyProfile.button")} />
                    </MenuItem>
                  )}
                  {this.state.readProfile && (
                    <MenuItem
                      button
                      onClick={this.handleProfile}
                      selected={this.state.profilePage}
                    >
                      <ListItemIcon className={classes.icon}>
                        <ProfileIcon />
                      </ListItemIcon>
                      <ListItemText primary={t("profile.button")} />
                    </MenuItem>
                  )}
                  {this.state.userManagement && (
                    <MenuItem
                      button
                      onClick={this.handleUserManagement}
                      selected={this.state.userManagementPage}
                    >
                      <ListItemIcon className={classes.icon}>
                        <UserIcon />
                      </ListItemIcon>
                      <ListItemText primary={t("userManagement.button")} />
                    </MenuItem>
                  )}
                  <MenuItem
                    button
                    onClick={this.handleContactUs}
                    selected={this.state.contactUsPage}
                  >
                    <ListItemIcon className={classes.icon}>
                      <ContactIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("contactUs.button")} />
                  </MenuItem>
                </List>
              )}

              {this.state.customDrawer && (
                <List>
                  <MenuItem
                    button
                    onClick={this.handleHome}
                    selected={this.state.homePage}
                  >
                    <ListItemText
                      primary={
                        <Typography
                          variant="h6"
                          style={{
                            color: window.sco_custom_theme.customDrawer.color,
                          }}
                        >
                          {t("home.button")}
                        </Typography>
                      }
                    />
                  </MenuItem>
                  {this.state.readAccount && (
                    <MenuItem
                      button
                      onClick={this.handleAccount}
                      selected={this.state.accountsPage}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            variant="h6"
                            style={{
                              color: window.sco_custom_theme.customDrawer.color,
                            }}
                          >
                            {t("accounts.button")}
                          </Typography>
                        }
                      />
                    </MenuItem>
                  )}
                  {this.state.readCompanyProfile && (
                    <MenuItem
                      button
                      onClick={this.handleCompanyProfile}
                      selected={this.state.companyProfilePage}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            variant="h6"
                            style={{
                              color: window.sco_custom_theme.customDrawer.color,
                            }}
                          >
                            {t("companyProfile.button")}
                          </Typography>
                        }
                      />
                    </MenuItem>
                  )}
                  {this.state.readProfile && (
                    <MenuItem
                      button
                      onClick={this.handleProfile}
                      selected={this.state.profilePage}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            variant="h6"
                            style={{
                              color: window.sco_custom_theme.customDrawer.color,
                            }}
                          >
                            {t("profile.button")}
                          </Typography>
                        }
                      />
                    </MenuItem>
                  )}
                  {this.state.userManagement && (
                    <MenuItem
                      button
                      onClick={this.handleUserManagement}
                      selected={this.state.userManagementPage}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            variant="h6"
                            style={{
                              color: window.sco_custom_theme.customDrawer.color,
                            }}
                          >
                            {t("userManagement.button")}
                          </Typography>
                        }
                      />
                    </MenuItem>
                  )}
                  <MenuItem
                    button
                    onClick={this.handleContactUs}
                    selected={this.state.contactUsPage}
                  >
                    <ListItemText
                      primary={
                        <Typography
                          variant="h6"
                          style={{
                            color: window.sco_custom_theme.customDrawer.color,
                          }}
                        >
                          {t("contactUs.button")}
                        </Typography>
                      }
                    />
                  </MenuItem>
                </List>
              )}
            </Drawer>
            <main className={classes.content}>
              {this.state.homePage && (
                <div>
                  <HomePage
                    history={this.props.history}
                    uiExclusionsList={this.state.uiExclusionsList}
                    viewOnly={this.state.viewOnly}
                    secureToken={this.props.secureToken}
                  >
                    {" "}
                  </HomePage>
                </div>
              )}
              {this.state.accountsPage && (
                <div>
                  <AccountsPage
                    history={this.props.history}
                    uiExclusionsList={this.state.uiExclusionsList}
                    viewOnly={this.state.viewOnly}
                    secureToken={this.props.secureToken}
                  >
                    {" "}
                  </AccountsPage>
                </div>
              )}
              {this.state.companyProfilePage && (
                <div>
                  <CompanyProfilePage
                    history={this.props.history}
                    uiExclusionsList={this.state.uiExclusionsList}
                    viewOnly={this.state.viewOnly}
                    secureToken={this.props.secureToken}
                    onNameChange={this.onCompanyNameChange}
                  >
                    {" "}
                  </CompanyProfilePage>
                </div>
              )}
              {this.state.profilePage && (
                <div>
                  <ProfilePage
                    history={this.props.history}
                    uiExclusionsList={this.state.uiExclusionsList}
                    viewOnly={this.state.viewOnly}
                    secureToken={this.props.secureToken}
                    userName={this.state.userName}
                    userRealm={this.state.realm}
                  >
                    {" "}
                  </ProfilePage>
                </div>
              )}
              {this.state.userManagementPage && (
                <div>
                  <UserManagementPage
                    history={this.props.history}
                    uiExclusionsList={this.state.uiExclusionsList}
                    viewOnly={this.state.viewOnly}
                    secureToken={this.props.secureToken}
                  >
                    {" "}
                  </UserManagementPage>
                </div>
              )}
              {this.state.contactUsPage && (
                <div>
                  <ContactUsPage
                    history={this.props.history}
                    uiExclusionsList={this.state.uiExclusionsList}
                    viewOnly={this.state.viewOnly}
                    secureToken={this.props.secureToken}
                  >
                    {" "}
                  </ContactUsPage>
                </div>
              )}
            </main>
          </div>
        )}
      </div>
    );
  }
}
MainPage.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withTranslation()(withStyles(styles)(MainPage));
